import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import Close from "@material-ui/icons/Close";
import React from "react";

interface TableSearchFieldProps {
  margin?: "none" | "normal";
  className?: string;
  search?: string | null;
  searchDebounceMilliseconds?: number;
  onSearchChange: (search?: string) => void;
}

interface TableSearchFieldState {
  search?: string | null;
}

export class TableSearchFieldComponent extends React.Component<TableSearchFieldProps, TableSearchFieldState> {
  private searchDebounceTimeoutId: number | undefined;

  constructor(props: TableSearchFieldProps) {
    super(props);

    const { search } = this.props;

    this.state = { search };
  }

  public render() {
    const { margin, className } = this.props;
    const { search } = this.state;

    return (
      <FormControl fullWidth={true} margin={margin} className={className}>
        <Input
          type="text"
          value={search || ""}
          placeholder="Search"
          style={{ width: "100%" }}
          endAdornment={
            search && (
              <InputAdornment position="end">
                <IconButton aria-label="Clear search" onClick={this.clearSearch}>
                  <Close />
                </IconButton>
              </InputAdornment>
            )
          }
          onChange={this.handleSearchChange}
        />
      </FormControl>
    );
  }

  private handleSearchChange = (event: any) => {
    // Default search debounce is 250 milliseconds
    const { searchDebounceMilliseconds = 250, onSearchChange } = this.props;
    const search = event.target.value;

    if (this.searchDebounceTimeoutId) {
      clearTimeout(this.searchDebounceTimeoutId);
    }

    this.setState({ search }, () => {
      this.searchDebounceTimeoutId = window.setTimeout(() => {
        onSearchChange(search);
      }, searchDebounceMilliseconds);
    });
  };

  private clearSearch = () => {
    const { onSearchChange } = this.props;

    this.setState({ search: undefined }, () => {
      onSearchChange(undefined);
    });
  };
}

export const TableSearchField = TableSearchFieldComponent;
